import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: absolute;
  z-index: 100;
  background: white;
  border: 1px solid ${(p) => p.theme.colors.greyblue};
  top: ${(p) => p.y}px;
  left: ${(p) => p.x}px;
  transform: translate(-50%, -50%);
  width: 40%;
  max-width: 115px;
  text-align: center;
  font-size: 12px;
  padding: 5px;
  border-radius: 5px;
  pointer-events: none;
  user-select: none;
`;

export default function ChartNotification({ text, x, y, maxWidth }) {
  return (
    <Wrapper maxWidth={maxWidth} x={x} y={y}>
      {text}
    </Wrapper>
  );
}
